
import { motion } from 'framer-motion';

export default function AboutSection() {
  const values = [
    {
      icon: 'ri-sparkling-line',
      title: 'Deus',
      description: 'Fé e propósito guiam cada decisão e projeto que realizamos'
    },
    {
      icon: 'ri-heart-line',
      title: 'Família',
      description: 'Valores familiares refletidos no cuidado com cada cliente'
    },
    {
      icon: 'ri-medal-line',
      title: 'Excelência Técnica',
      description: 'Padrão internacional de qualidade em todos os serviços'
    },
    {
      icon: 'ri-hand-heart-line',
      title: 'Palavra Honrada',
      description: 'Compromisso e integridade em cada promessa feita'
    }
  ];

  return (
    <section id="sobre" className="py-16 lg:py-32 bg-[#F4F4F4]">
      <div className="max-w-[1400px] mx-auto px-5 lg:px-8">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="w-full lg:w-[40%]"
          >
            <div className="relative">
              <img
                src="https://readdy.ai/api/search-image?query=professional%20landscaping%20team%20installing%20premium%20artificial%20grass%20luxury%20garden%20construction%20workers%20in%20action%20high%20end%20turf%20installation%20technical%20precision%20work%20modern%20equipment%20clean%20professional%20setting%20architectural%20quality%20image&width=600&height=800&seq=about-vitta-1&orientation=portrait"
                alt="Equipe Vitta Prime Grass"
                className="w-full h-[350px] lg:h-[600px] object-cover rounded-lg border-2 border-[#C5A059] shadow-[0_8px_24px_rgba(0,0,0,0.08)]"
                translate="no"
              />
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="w-full lg:w-[60%]"
          >
            <div className="mb-4">
              <span className="font-montserrat text-[#C5A059] text-sm uppercase tracking-[3px]">Nossos Valores</span>
            </div>
            <h2 className="font-cinzel font-semibold text-[#2D2D2D] text-3xl lg:text-5xl leading-[1.3] mb-8 lg:mb-12">
              Excelência Construída Sobre Princípios
            </h2>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
              {values.map((value, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.1, duration: 0.6 }}
                  className="group cursor-pointer"
                >
                  <div className="w-12 h-12 rounded-full border-2 border-[#C5A059] flex items-center justify-center mb-4 group-hover:bg-[#C5A059] transition-all">
                    <i className={`${value.icon} text-[#C5A059] text-2xl group-hover:text-white transition-colors`}></i>
                  </div>
                  <h3 className="font-montserrat font-semibold text-[#1B4D3E] text-xl mb-2">{value.title}</h3>
                  <p className="font-montserrat text-[#2D2D2D]/70 text-[15px] leading-[1.6]" translate="no">{value.description}</p>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
